uic-horizontal-menu-container {
  align-items: normal;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  font-size: var(--uic-font-size-normal);
  font-weight: var(--uic-font-weight-bold);
  height: 100%;
  overflow-y: auto;
  position: relative;
  vertical-align: top;
}

.uic-horizontal-menu-container__tab-list__main,
.uic-horizontal-menu-container__tab-list__flyout,
.uic-horizontal-menu-container__tab-list__flyout-last {
  align-items: normal;
  box-sizing: border-box;
  flex-direction: column;
  font-size: var(--uic-font-size-normal);
  font-weight: var(--uic-font-weight-bold);
  height: 100%;
  position: relative;
  vertical-align: top;
  width: 200px;
}

.uic-horizontal-menu-container__tab-list__main {
  background: var(--uic-tab-sub-background-color) !important;
  border-right: 1px solid;

  uic-tab[selected] {
    border-right: 1px solid var(--uic-tab-sub-background-color);
  }

  .uic-tab-list__indicator {
    left: -1px;
  }
}

.uic-horizontal-menu-container__tab-list__flyout {
  border-right: 1px solid;
  display: inline-flex;

  uic-tab[selected] {
    border-right: 1px solid var(--uic-tab-content-background-color);
  }
}

.uic-horizontal-menu-container__tab-list__flyout-last {
  box-shadow: 1px 0 1px 0 var(--uic-atom-shadow-color-submenu), 2px 0 2px 0 var(--uic-atom-shadow-color-secondary);
  display: inline-flex;

  uic-tab[selected] {
    border-right: 1px solid var(--uic-tab-content-background-color);
  }
}

.uic-horizontal-menu-container__tab-list__hidden {
  display: none;
}

.uic-horizontal-menu-container__icon__arrow {
  color: var(--uic-color-black);
  display: block;
  height: var(--uic-icon-dimensions-default);
  position: absolute;
  right: 16.5px;
  top: 50%;
  transform: translateY(-50%);
  width: var(--uic-icon-dimensions-default);
}

.uic-horizontal-menu-container__icon__wrapper {
  box-sizing: border-box;
  display: inline-block;
  position: relative;

  &__icon {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    width: 50px;

    svg {
      height: var(--uic-icon-dimensions-default);
      width: var(--uic-icon-dimensions-default);
    }
  }

  .uic-tab__label {
    > slot-fb {
      width: 116px;
    }
  }
}

.uic-horizontal-menu-container__tab__mainmenu-selected,
.uic-horizontal-menu-container__tab__mainmenu,
.uic-horizontal-menu-container__tab__submenu-selected,
.uic-horizontal-menu-container__tab__submenu-selected-last,
.uic-horizontal-menu-container__tab__submenu,
.uic-horizontal-menu-container__tab__submenu-last {
  --uic-tab-text-color-selected: var(--uic-color-blue5);
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  border-top: transparent;
  font-family: 'Open Sans', sans-serif;
  height: 64px;
  padding-left: 32px;
  white-space: normal;
}

.uic-horizontal-menu-container__tab__mainmenu {
  font-weight: var(--uic-font-weight-normal);
}

.uic-horizontal-menu-container__tab__mainmenu-selected,
.uic-horizontal-menu-container__tab__mainmenu {
  left: -1px;
  width: calc(100% + 2px);

  span,
  span slot {
    pointer-events: none;
  }
}

.uic-horizontal-menu-container__tab__submenu-selected {
  background-color: var(--uic-color-white);
  width: calc(100% + 1px);

  &:hover {
    background-color: var(--uic-color-white);
  }
}

.uic-horizontal-menu-container__tab__submenu-selected-last {
  background-color: var(--uic-color-white);
  width: 100%;

  &:hover {
    background-color: var(--uic-color-white);
  }
}

.uic-horizontal-menu-container__tab__submenu {
  border-right: 1px solid;
  font-weight: var(--uic-font-weight-normal);
  width: calc(100% + 1px);
}

.uic-horizontal-menu-container__tab__submenu-last {
  border-right: 1px solid transparent !important;
  font-weight: var(--uic-font-weight-normal);
  width: 100%;
}

.uic-horizontal-menu-container__shadow-root {
  --uic-tab-indicator-color: var(--uic-color-blue2);
  display: inline-flex;
  height: 100%;
}
